import { Image, SimpleGrid, Text } from "@mantine/core";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Page from "../../../components/Page";
import "./styles.css";

const Index = ({ coorporate, setCoorporate }) => {
  const [files, setFiles] = useState([]);

  const previews = files.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    return (
      <Image
        key={index}
        src={imageUrl}
        imageProps={{ onLoad: () => URL.revokeObjectURL(imageUrl) }}
      />
    );
  });

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="corporate-main">
        <h2 className="text-dark text-center">Corporate Culture</h2>
        <p style={{ margin: "0px", fontWeight: "600", fontSize: "12px" }}>
          CORPORATE CULTURE SUMMARY
        </p>
        <textarea
          placeholder="Corporate Summary"
          onChange={(v) =>
            setCoorporate((a) => ({
              ...a,
              corporateCultureSummary: v.target.value,
            }))
          }
          defaultValue={coorporate?.corporateCultureSummary}
          rows={5}
          style={{
            border: "1px solid rgb(0,0,0,0.1)",
            borderRadius: "10px",
            padding: "5px",
            outline: "none",
          }}
        />
        <hr />
        <p style={{ margin: "0px", fontWeight: "500", fontSize: "12px" }}>
          ADD LINK FROM VIMEO OR YOUTUBE
        </p>
        <InputField
          placeholder={"Paste video link here..."}
          icon="vimeo"
          style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          value={coorporate?.corporateCultureVideoLink}
          onChange={(v) =>
            setCoorporate((a) => ({
              ...a,
              corporateCultureVideoLink: v.target.value,
            }))
          }
        />
        <hr />
        <div className="d-flex flex-column gap-3">
          <h5 className="text-dark text-center">Photo Gallery</h5>
          <InputField
            placeholder={"Photo Gallery Title..."}
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            value={coorporate?.photoGalleryTitle}
            onChange={(v) =>
              setCoorporate((a) => ({
                ...a,
                photoGalleryTitle: v.target.value,
              }))
            }
          />
          <Dropzone
            accept={IMAGE_MIME_TYPE}
            onDrop={(v) => {
              setFiles(v);
              setCoorporate((a) => ({
                ...a,
                companyGallery: v,
              }));
            }}
          >
            <Text align="center">Drop images here</Text>
          </Dropzone>
          <SimpleGrid
            cols={4}
            breakpoints={[{ maxWidth: "sm", cols: 1 }]}
            mt={previews.length > 0 ? "xl" : 0}
          >
            {files.length > 0 ? (
              previews
            ) : (
              <div className="d-flex gap-4">
                {coorporate?.companyGallery &&
                  coorporate?.companyGallery.map((obj) => {
                    return <img src={obj.fileName} width="200px" />;
                  })}
              </div>
            )}
          </SimpleGrid>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
